






























































































































import {
  Component, Emit, Prop, Ref, Vue,
} from 'vue-property-decorator';
import VueMultiselect from 'vue-multiselect';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { find } from 'lodash';
import { BankAccount, Transaction } from '@/api/payment-orders';
import { formatMoney, parseMoney } from '@/utils/format';
import ScanField from '@/components/ScanField.vue';
import TransactionDto from '@/interfaces/transaction.dto';
import PartyModal from '@/components/PartyModal.vue';
import Deferred from '@/utils/deferred';
import ChoosePartyModal from '@/components/ChoosePartyModal.vue';

@Component({
  components: {
    ChoosePartyModal,
    PartyModal,
    VueMultiselect,
    ValidationProvider,
    ValidationObserver,
    ScanField,
  },
})
export default class BankSlip extends Vue {
  @Prop({
    type: String,
    default: null,
  })
  readonly id!: string | null;

  @Prop({
    type: String,
    default: null,
  })
  readonly creditorId!: string | null;

  @Prop({
    type: Number,
    default: null,
  })
  readonly amount!: number | null;

  @Prop({
    type: String,
    default: 'HR99',
  })
  readonly model!: string;

  @Prop({
    type: String,
    default: '',
  })
  readonly beneficiaryRef!: string;

  @Prop({
    type: String,
    default: 'Račun',
  })
  readonly additionalInfo!: string;

  @Prop({
    type: Array,
    default: () => [],
  })
  readonly creditors!: BankAccount[];

  creditorIdData = this.creditorId;

  amountData = this.amount;

  modelData = this.model;

  beneficiaryRefData = this.beneficiaryRef;

  additionalInfoData = this.additionalInfo;

  isScanMode = false;

  creditor: Partial<BankAccount> | null = null;

  isCreditorModalOpen = false;

  isChooseCreditorModalOpen = false;

  @Ref('scanField')
  readonly scanField!: ScanField;

  get creditorComputed() {
    return this.creditorIdData ? this.findCreditorById(this.creditorIdData) : null;
  }

  async onCreditorSelectCheck(creditor: BankAccount | null) {
    console.log({ creditor });
    if (!creditor) {
      this.creditorIdData = null;

      return;
    }

    if (!creditor?.iban) {
      this.creditorIdData = (await this.chooseCreditor(creditor))?.id;

      return;
    }

    this.creditorIdData = creditor?.id || null;
  }

  get amountComputed() {
    return formatMoney(this.amountData);
  }

  set amountComputed(newAmount: string | null) {
    this.amountData = parseMoney(newAmount);
  }

  get modelComputed() {
    return this.modelData.slice(2);
  }

  set modelComputed(newModel: string) {
    this.modelData = `HR${newModel.trim()}`;
  }

  get beneficiaryRefComputed() {
    return this.beneficiaryRefData;
  }

  set beneficiaryRefComputed(beneficiaryRef: string) {
    this.beneficiaryRefData = beneficiaryRef.trim();
  }

  get additionalInfoComputed() {
    return this.additionalInfoData;
  }

  set additionalInfoComputed(additionalInfo: string) {
    this.additionalInfoData = additionalInfo.trim();
  }

  get transaction() {
    return {
      id: this.id,
      creditor: this.findCreditorById(this.creditorIdData),
      amount: this.amountData,
      model: this.modelData,
      beneficiaryRef: this.beneficiaryRefData,
      additionalInfo: this.additionalInfoData,
    };
  }

  findCreditorById(id: string | null) {
    if (id === null) {
      return null;
    }

    return find(this.creditors, ['id', id]) || null;
  }

  findCreditorByIban(iban: string | null) {
    if (iban === null) {
      return null;
    }

    return find(this.creditors, ['iban', iban]) || null;
  }

  async onTransactionScan({
    amount, info, model, ref, crdtrNm, crdtrIban,
  }: TransactionDto) {
    this.amountData = amount;
    this.modelData = model;
    this.beneficiaryRefData = ref;
    this.additionalInfoData = info;

    const creditor = this.findCreditorByIban(crdtrIban);
    const creditorInitial = { name: crdtrNm, iban: crdtrIban };
    this.creditorIdData = creditor?.id || (await this.chooseCreditor(creditorInitial)).id;
  }

  creditorDeferred: Deferred<BankAccount> | null = null;

  openChooseCreditorModal() {
    this.isChooseCreditorModalOpen = true;
  }

  closeChooseCreditorModal() {
    this.isChooseCreditorModalOpen = false;
  }

  async chooseCreditor(creditorInitial: Partial<BankAccount> | null = null) {
    this.creditor = creditorInitial;

    this.openChooseCreditorModal();

    this.creditorDeferred = new Deferred<BankAccount>();

    const creditor = await this.creditorDeferred;

    this.creditorDeferred = null;

    return creditor;
  }

  onCreditorSelect(creditor: BankAccount) {
    // eslint-disable-next-line no-unused-expressions
    this.creditorDeferred?.resolve(creditor);

    this.closeChooseCreditorModal();
  }

  @Emit('cancel')
  reset() {
    this.creditorIdData = this.creditorId;
    this.amountData = this.amount;
    this.modelData = this.model;
    this.beneficiaryRefData = this.beneficiaryRef;
    this.additionalInfoData = this.additionalInfo;
  }

  scanModeOn() {
    this.isScanMode = true;
    this.scanField.focusScanArea();
  }

  openCreditorModal(creditor: Partial<BankAccount> | null = null) {
    this.creditor = creditor;
    this.isCreditorModalOpen = true;
  }

  onCreditorSubmit(creditor: BankAccount) {
    this.creditorIdData = creditor.id;
  }

  onTransactionAccept() {
    if (this.creditorIdData === null || this.amountData === null) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const creditor = this.findCreditorById(this.creditorIdData);

    if (!creditor) {
      return;
    }

    const transaction = Transaction.from(
      creditor, this.amountData, {
        model: this.modelData,
        beneficiaryRef: this.beneficiaryRefData,
        additionalInfo: this.additionalInfoData,
        isScanned: false,
      },
    );

    if (this.id) {
      transaction.id = this.id;
    }

    this.$emit('transaction:submit', transaction);
  }

  async onCreditorClick() {
    if (!this.creditorIdData) {
      this.openCreditorModal();
    } else {
      this.openCreditorModal(this.creditorComputed);
    }
  }
}
